"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function OrderFromJSON(json) {
    return OrderFromJSONTyped(json, false);
}
exports.OrderFromJSON = OrderFromJSON;
function OrderFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'symbol': !runtime_1.exists(json, 'symbol') ? undefined : json['symbol'],
        'strategy': !runtime_1.exists(json, 'strategy') ? undefined : _1.StrategyFromJSON(json['strategy']),
        'timeInForce': !runtime_1.exists(json, 'timeInForce') ? undefined : _1.TimeInForceFromJSON(json['timeInForce']),
        'orderType': !runtime_1.exists(json, 'orderType') ? undefined : _1.OrderTypeFromJSON(json['orderType']),
        'orderStatus': !runtime_1.exists(json, 'orderStatus') ? undefined : _1.OrderStatusFromJSON(json['orderStatus']),
        'numberOfLegs': !runtime_1.exists(json, 'numberOfLegs') ? undefined : json['numberOfLegs'],
        'quantity': !runtime_1.exists(json, 'quantity') ? undefined : json['quantity'],
        'remainingQuantity': !runtime_1.exists(json, 'remainingQuantity') ? undefined : json['remainingQuantity'],
        'executedQuantity': !runtime_1.exists(json, 'executedQuantity') ? undefined : json['executedQuantity'],
        'unallocatedQuantity': !runtime_1.exists(json, 'unallocatedQuantity') ? undefined : json['unallocatedQuantity'],
        'createdAt': !runtime_1.exists(json, 'createdAt') ? undefined : (json['createdAt']),
        'executedAt': !runtime_1.exists(json, 'executedAt') ? undefined : (json['executedAt']),
        'startTimeUtc': !runtime_1.exists(json, 'startTimeUtc') ? undefined : (json['startTimeUtc']),
        'endTimeUtc': !runtime_1.exists(json, 'endTimeUtc') ? undefined : (json['endTimeUtc']),
        'gain': !runtime_1.exists(json, 'gain') ? undefined : json['gain'],
        'gainPercent': !runtime_1.exists(json, 'gainPercent') ? undefined : json['gainPercent'],
        'cancelable': !runtime_1.exists(json, 'cancelable') ? undefined : json['cancelable'],
        'replaceable': !runtime_1.exists(json, 'replaceable') ? undefined : json['replaceable'],
        'entry': !runtime_1.exists(json, 'entry') ? undefined : _1.EntryFromJSON(json['entry']),
        'commission': !runtime_1.exists(json, 'commission') ? undefined : json['commission'],
        'limitPrice': !runtime_1.exists(json, 'limitPrice') ? undefined : json['limitPrice'],
        'executedPrice': !runtime_1.exists(json, 'executedPrice') ? undefined : json['executedPrice'],
        'legOrders': !runtime_1.exists(json, 'legOrders') ? undefined : (json['legOrders'].map(OrderFromJSON)),
        'name': !runtime_1.exists(json, 'name') ? undefined : json['name'],
        'companyName': !runtime_1.exists(json, 'companyName') ? undefined : json['companyName'],
        'underlyingSymbol': !runtime_1.exists(json, 'underlyingSymbol') ? undefined : json['underlyingSymbol'],
        'min': !runtime_1.exists(json, 'min') ? undefined : json['min'],
        'max': !runtime_1.exists(json, 'max') ? undefined : json['max'],
        'marketPosition': !runtime_1.exists(json, 'marketPosition') ? undefined : _1.MarketPositionFromJSON(json['marketPosition']),
        'expirationDate': !runtime_1.exists(json, 'expirationDate') ? undefined : (json['expirationDate']),
        'orderSide': !runtime_1.exists(json, 'orderSide') ? undefined : _1.OrderSideFromJSON(json['orderSide']),
        'confirmUrl': !runtime_1.exists(json, 'confirmUrl') ? undefined : json['confirmUrl'],
        'value': !runtime_1.exists(json, 'value') ? undefined : json['value'],
        'tradeId': !runtime_1.exists(json, 'tradeId') ? undefined : json['tradeId'],
    };
}
exports.OrderFromJSONTyped = OrderFromJSONTyped;
function OrderToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'symbol': value.symbol,
        'strategy': _1.StrategyToJSON(value.strategy),
        'timeInForce': _1.TimeInForceToJSON(value.timeInForce),
        'orderType': _1.OrderTypeToJSON(value.orderType),
        'orderStatus': _1.OrderStatusToJSON(value.orderStatus),
        'numberOfLegs': value.numberOfLegs,
        'quantity': value.quantity,
        'remainingQuantity': value.remainingQuantity,
        'executedQuantity': value.executedQuantity,
        'unallocatedQuantity': value.unallocatedQuantity,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt),
        'executedAt': value.executedAt === undefined ? undefined : (value.executedAt),
        'startTimeUtc': value.startTimeUtc === undefined ? undefined : (value.startTimeUtc),
        'endTimeUtc': value.endTimeUtc === undefined ? undefined : (value.endTimeUtc),
        'gain': value.gain,
        'gainPercent': value.gainPercent,
        'cancelable': value.cancelable,
        'replaceable': value.replaceable,
        'entry': _1.EntryToJSON(value.entry),
        'commission': value.commission,
        'limitPrice': value.limitPrice,
        'executedPrice': value.executedPrice,
        'legOrders': value.legOrders === undefined ? undefined : (value.legOrders.map(OrderToJSON)),
        'name': value.name,
        'companyName': value.companyName,
        'underlyingSymbol': value.underlyingSymbol,
        'min': value.min,
        'max': value.max,
        'marketPosition': _1.MarketPositionToJSON(value.marketPosition),
        'expirationDate': value.expirationDate === undefined ? undefined : (value.expirationDate),
        'orderSide': _1.OrderSideToJSON(value.orderSide),
        'confirmUrl': value.confirmUrl,
        'value': value.value,
        'tradeId': value.tradeId,
    };
}
exports.OrderToJSON = OrderToJSON;
